import {
  DeleteWithConfirmButton,
  Group,
  GroupTitle,
  LongTextField,
  ReferenceListField,
  useFieldLabel,
  useMakeRedirect,
  useTabVisibility,
} from "ra-friendsofbabba";
import {
  EditButton,
  NumberField,
  TextField,
  useInput,
  useQueryWithStore,
  useTranslate,
} from "react-admin";
import React, { useMemo } from "react";

import ExpandedRow from "../ExpandedRow";
import HelpBlock from "../../component/HelpBlock";

const SmartEditButton = ({ disabled, ...props }) => (
  <EditButton {...props} disabled={disabled || !props?.record?.is_editable} />
);
const SmartDeleteButton = ({ disabled, ...props }) => (
  <DeleteWithConfirmButton
    {...props}
    disabled={disabled || !props?.record?.is_editable}
  />
);

const WpsField = ({ tab = 1, ...props }) => {
  useInput({ ...props });
  const visible = useTabVisibility(tab);
  const fieldLabel = useFieldLabel({ ...props });
  const translate = useTranslate();
  const { data: config } = useQueryWithStore({
    type: "get",
    resource: "executive-project-wps/config",
    payload: {
      executive_project_id: props?.record?.id,
    },
  });
  const canAdd = useMemo(() => config?.duration < 18, [config?.duration]);
  const removeRedir = useMakeRedirect({
    tab,
    ...props,
  });
  if (!visible) {
    return null;
  }

  return (
    <Group {...props} wrapper>
      <GroupTitle
        title={fieldLabel(props?.source)}
        subTitle={translate(
          "resources.executive-projects.fields.executive_project_wps.help"
        )}
      />
      <HelpBlock
        elevation={1}
        resource="executive-project-wps"
        context="list"
      />
      <ReferenceListField
        {...props}
        tab={tab}
        perPage={10}
        addLabel={false}
        reference="executive-project-wps"
        target="executive_project_id"
        sort={{ field: "id", order: "ASC" }}
        createLabel="ra.action.add_wp"
        expand={<ExpandedRow />}
        create={!props.disabled && canAdd}
        modify={false /*!props.disabled*/}
        remove={false /*!props.disabled*/}
        mobilePrimaryText="title"
        mobileSecondaryText="start_month"
        mobileTertiaryText="duration"
        mobileBreakpoint="xs"
      >
        <TextField source="index" />
        <LongTextField source="title" maxWidth={200} />
        <NumberField source="start_month" />
        <NumberField source="duration" />
        <SmartEditButton disabled={props.disabled} />
        <SmartDeleteButton redirect={removeRedir} disabled={props.disabled} />
      </ReferenceListField>
    </Group>
  );
};
export default WpsField;
